import ModalView from '../components/rover_modal';

import '../backbone/views/archive_modal_view';

$(() => {
  let $conversation = null;
  let saveOptions = null;
  let conversationDetailUrl = null;
  const SOURCE_HEADER = Rover.api.getSourceHeader(
    $('.js-book-or-archive-actions').length > 0 ? 'web/inbox-pending' : 'web/conversation-detail'
  );

  const save = function(options) {
    saveOptions = options;

    if (
      typeof options.shouldAcceptNonSpayed !== 'undefined' ||
      typeof options.shouldAcceptNonNeutered !== 'undefined'
    ) {
      $.ajax({
        url: Rover.urls.serviceHostingPreferences,
        method: 'PUT',
        contentType: 'application/json',
        data: JSON.stringify({
          accepts_unspayed_females: options.shouldAcceptNonSpayed,
          accepts_non_neutered_males: options.shouldAcceptNonNeutered,
        }),
        success() {
          archive();
        },
        error: onSaveError,
      });
    } else {
      archive();
    }
  };

  var onSaveError = function() {
    const failureModal = new ModalView({
      title: 'Failure',
      content: 'Your preferences could not be updated. Please try again in a few moments.',
      showFooter: true,
      disableCancel: true,
      okCloses: true,
    });
    failureModal.open();
  };

  var archive = function() {
    $.ajax({
      url: conversationDetailUrl,
      method: 'PUT',
      contentType: 'application/json',
      headers: SOURCE_HEADER,
      data: JSON.stringify({
        provider_archived_status: saveOptions.reason ? { reason: saveOptions.reason } : null,
      }),
      success: showArchiveSuccessModal,
      error: showArchiveErrorModal,
    });
  };

  var showArchiveSuccessModal = function() {
    const confirmationModal = new ModalView({
      title: 'Success',
      content: 'Your conversation has been archived',
      showFooter: true,
      cancelText: 'Undo',
      okCloses: true,
    });

    confirmationModal.on('cancel', () => {
      undoArchive();
    });

    confirmationModal.open();
    toggleUndoButton(true);
  };

  var showArchiveErrorModal = function() {
    const failureModal = new ModalView({
      title: 'Failure',
      content: 'Your conversation couldn’t be archived. Please try again in a few moments.',
      showFooter: true,
      disableCancel: true,
      okCloses: true,
    });

    failureModal.open();
    toggleUndoButton(false);
  };

  var undoArchive = function() {
    $.ajax({
      url: conversationDetailUrl,
      method: 'PUT',
      contentType: 'application/json',
      headers: SOURCE_HEADER,
      data: JSON.stringify({
        provider_archived_status: null,
      }),
      success() {
        toggleUndoButton(false);
      },
      error: showArchiveUndoErrorModal,
    });
  };

  var showArchiveUndoErrorModal = function() {
    const failureModal = new ModalView({
      title: 'Failure',
      content: 'Unable to undo archiving. Please try again in a few moments.',
      showFooter: true,
      disableCancel: true,
      okCloses: true,
    });
    failureModal.open();
  };

  var toggleUndoButton = function(show) {
    $conversation.find('.js-archive-complete').toggle(show);
    $conversation.find('.js-move-to-archive').toggle(!show);
  };

  $('.js-move-to-archive').on('click', function(event) {
    $conversation = $(this).closest('.js-conversation-container');
    const currentOpk = $conversation.attr('data-opk');
    conversationDetailUrl = $conversation.data('conversation-detail-url');

    const archiveConversationBtn = $(event.currentTarget);
    const eventData = _.extend(
      {},
      { event: archiveConversationBtn.data('event') },
      archiveConversationBtn.data('event-merge')
    );
    dataLayer.push(eventData);

    window.archive_modal = new Rover.views.ArchiveModalView({
      title: 'Archive this request',
      content: $('.js-archive-modal'),
      showFooter: true,
      cancelText: null,
      okCloses: true,
      okText: 'Save',
      conversationDetailUrl,
      onSave: save,
    });

    window.archive_modal.open();
  });

  $('.js-undoarchive').on('click', () => {
    undoArchive();
  });
});



// WEBPACK FOOTER //
// ./js/plugins/archive.js